import type { LoyaltyActionRewardCTANav } from 'loyalty/constants/loyaltyActionRewards'
import { isAndroid, isAndroidAppUserAgent, isIOS, isIOSAppUserAgent } from 'lib/web/deviceUtils'

const LUXURY_ESCAPES_APP_SMART_LINK_IOS = 'https://app.luxuryescapes.com/3WHB/1aab092'
const LUXURY_ESCAPES_APP_SMART_LINK_ANDROID = 'https://app.luxuryescapes.com/3WHB/feb04c69'

export type LoyaltyActionRewardCTANavDestination =
  | { kind: 'route'; to: string }
  | { kind: 'external'; href: string } // different prop handling for external links.

interface GetLoyaltyActionRewardCTANavParams {
  osName: string
  userAgent: string
}

function getLuxuryEscapesAppSmartLink({
  osName,
  userAgent,
}: GetLoyaltyActionRewardCTANavParams): string {
  if (isAndroidAppUserAgent(userAgent) || isAndroid(osName)) {
    return LUXURY_ESCAPES_APP_SMART_LINK_ANDROID
  }

  if (isIOSAppUserAgent(userAgent) || isIOS(osName)) {
    return LUXURY_ESCAPES_APP_SMART_LINK_IOS
  }

  return LUXURY_ESCAPES_APP_SMART_LINK_IOS
}

export default function getLoyaltyActionRewardCTANav(
  ctaNav: LoyaltyActionRewardCTANav,
  { osName, userAgent }: GetLoyaltyActionRewardCTANavParams,
): LoyaltyActionRewardCTANavDestination {
  switch (ctaNav.kind) {
    case 'route':
      return ctaNav
    case 'app-smart-link':
      return {
        kind: 'external',
        href: getLuxuryEscapesAppSmartLink({ osName, userAgent }),
      }
  }
}
